{
  "clinicalNotes": "病歷文件",
  "noteType": "文件類型",
  "author": "作者",
  "dateTime": "日期/時間",
  "content": "內容",
  "addNote": "新增病歷",
  "editNote": "編輯病歷",
  "signNote": "簽署病歷",
  "signed": "已簽署",
  "unsigned": "未簽署",
  "types": {
    "progressNote": "病程紀錄",
    "admissionNote": "入院紀錄",
    "dischargeNote": "出院紀錄",
    "consultNote": "會診紀錄",
    "procedureNote": "手術紀錄"
  },
  "editor": {
    "newNote": "新增病歷",
    "titlePlaceholder": "病歷標題…",
    "create": "建立",
    "cancel": "取消",
    "cosignFilterLabel": "只顯示需我聯簽的病歷",
    "emptyNoCosign": "沒有需要您聯簽的病歷",
    "emptyNoNotes": "暫無病歷",
    "emptySelection": "請選擇病歷或新建一份",
    "emptySelectionHint": "從左邊列表揀選,或撳「+ 新增病歷」開始。",
    "unknownAuthor": "未知",
    "needsCosignBadge": "需聯簽",
    "amendmentBanner": "病歷 #{{parentId}} 的修訂 — 原因:{{reason}}",
    "signedBanner": "由 {{name}} 於 {{when}} 簽署 — 此病歷為唯讀。",
    "signedByFallback": "醫生",
    "saving": "儲存中…",
    "autoSaved": "已自動儲存",
    "actions": {
      "saveDraft": "儲存草稿",
      "signNote": "簽署病歷",
      "amend": "修訂",
      "cosign": "聯簽",
      "printLabel": "列印病歷"
    },
    "copyForward": "沿用上一份病歷",
    "copyForwardHint": "將沿用 {{date}} 已簽署的病歷——請逐項覆核並更新",
    "copiedForwardBadge": "沿用"
  },
  "dialog": {
    "sign": {
      "title": "簽署病歷",
      "body": "確認簽署此病歷?此操作無法撤銷。簽署後病歷將變成唯讀。",
      "cancel": "取消",
      "confirm": "確認簽署"
    },
    "amend": {
      "title": "修訂病歷",
      "body": "請提供今次修訂嘅原因。病歷將被更新並標記為已修訂。",
      "reasonPlaceholder": "修訂原因…",
      "cancel": "取消",
      "confirm": "確認修訂"
    },
    "cosign": {
      "title": "聯簽病歷",
      "body": "確認聯簽此病歷?表示您已審閱並認可此病歷內容。",
      "cancel": "取消",
      "confirm": "確認聯簽"
    }
  },
  "toast": {
    "created": "病歷已建立",
    "createFailed": "建立病歷失敗",
    "titleRequired": "請輸入病歷標題",
    "draftSaved": "草稿已儲存",
    "signed": "病歷簽署成功",
    "signFailed": "簽署病歷失敗",
    "amended": "病歷修訂成功",
    "amendFailed": "修訂病歷失敗",
    "amendReasonRequired": "請提供修訂原因",
    "cosigned": "病歷聯簽成功",
    "cosignFailed": "聯簽病歷失敗"
  },
  "status": {
    "draft": "草稿",
    "unsigned": "未簽署",
    "signed": "已簽署",
    "amended": "已修訂",
    "cosigned": "已聯簽",
    "cosignNeeded": "需聯簽",
    "pendingSignature": "待簽署",
    "addendum": "補充紀錄",
    "cosignPending": "待聯簽"
  },
  "worklist": {
    "title": "未簽署病歷工作列表",
    "backToDashboard": "工作台",
    "filtersHeading": "篩選",
    "filterAllNoteTypes": "全部文件類型",
    "filterAllStatuses": "全部狀態",
    "filterAuthorPlaceholder": "依作者篩選…",
    "dateFromAria": "起始日期",
    "dateToAria": "結束日期",
    "columns": {
      "patient": "病人",
      "mrn": "MRN",
      "noteType": "文件類型",
      "noteTitle": "標題",
      "author": "作者",
      "created": "建立時間",
      "status": "狀態",
      "actions": "操作"
    },
    "actions": {
      "signSelected": "簽署所選({{count}})",
      "signing": "簽署緊…",
      "open": "開啟",
      "refresh": "重新整理"
    },
    "loading": "正在載入病歷…",
    "empty": "搵唔到未簽署病歷",
    "loadError": "載入未簽署病歷失敗",
    "retry": "重試",
    "toast": {
      "noneSelected": "未選擇病歷",
      "signed_one": "{{count}} 份病歷簽署成功",
      "signed_other": "{{count}} 份病歷簽署成功",
      "signFailed": "部分病歷簽署失敗",
      "partiallySigned_one": "{{count}} 份病歷簽署成功，{{failed}} 份失敗",
      "partiallySigned_other": "{{count}} 份病歷簽署成功，{{failed}} 份失敗"
    }
  },
  "type": {
    "progress": "病程紀錄",
    "historyPhysical": "H&P",
    "admission": "入院紀錄",
    "discharge": "出院摘要",
    "consult": "會診紀錄",
    "procedure": "處置紀錄",
    "operative": "手術紀錄",
    "nursing": "護理紀錄"
  },
  "template": {
    "list": {
      "title": "病歷範本",
      "backToDashboard": "工作台",
      "newButton": "新增範本",
      "columns": {
        "name": "名稱",
        "noteType": "文件類型",
        "specialty": "專科",
        "sections": "區段",
        "status": "狀態",
        "actions": "操作"
      },
      "active": "啟用",
      "inactive": "停用",
      "loading": "正在載入範本…",
      "empty": "暫無範本。請建立一個以開始使用。",
      "previewTitle": "範本預覽:{{name}}",
      "emptySection": "(空白)",
      "tooltips": {
        "preview": "預覽",
        "edit": "編輯",
        "activate": "啟用",
        "deactivate": "停用"
      },
      "toast": {
        "statusUpdated": "範本狀態已更新"
      }
    },
    "form": {
      "editTitle": "編輯範本",
      "createTitle": "建立範本",
      "fields": {
        "name": "範本名稱",
        "noteType": "文件類型",
        "specialty": "專科",
        "sections": "區段"
      },
      "required": "*",
      "namePlaceholder": "例如:標準病程紀錄",
      "selectNoteType": "選擇類型…",
      "selectSpecialty": "選擇專科…",
      "addSection": "新增區段",
      "sectionNamePlaceholder": "區段名稱(例如:主訴)",
      "sectionDefaultPlaceholder": "本區段嘅預設內容…",
      "cancel": "取消",
      "create": "建立範本",
      "update": "更新範本",
      "toast": {
        "created": "範本已建立",
        "updated": "範本已更新",
        "saveFailed": "儲存範本失敗",
        "nameAndTypeRequired": "名稱同文件類型必填",
        "atLeastOneSection": "至少需要一個區段"
      }
    },
    "specialty": {
      "general": "普通科",
      "internalMedicine": "內科",
      "surgery": "外科",
      "pediatrics": "兒科",
      "cardiology": "心臟科",
      "neurology": "腦神經科",
      "orthopedics": "矯形及創傷科",
      "emergencyMedicine": "急症科"
    },
    "scope": {
      "personal": "個人",
      "group": "群組",
      "global": "全院"
    },
    "state": {
      "draft": "草稿",
      "published": "已發佈"
    }
  },
  "components": {
    "clinicalNoteEditor": {
      "bold": "粗體",
      "italic": "斜體",
      "list": "清單",
      "templates": "範本 / 智慧短語",
      "saved": "已儲存 {{time}}",
      "notSaved": "未儲存",
      "charactersLabel": "字元",
      "save": "儲存{{noteType}}",
      "placeholder": "開始輸入您的{{noteType}}…輸入「.」可觸發智慧短語。",
      "smartPhrases": {
        "patientName": "病人姓名",
        "mrn": "病歷號",
        "dateOfBirth": "出生日期",
        "allergies": "過敏史",
        "vitals": "生命徵象",
        "medications": "用藥",
        "problemList": "問題清單"
      }
    }
  }
}
